import { ControllerPaletteColor } from './__palette-color';

export enum ControllerButtonColor {
  ContainedPrimaryDefaultBg = ControllerPaletteColor.Ngb500,
  ContainedPrimaryDefaultFg = ControllerPaletteColor.GrayWhite,
  ContainedPrimaryHoverBg = ControllerPaletteColor.Ngb400,
  ContainedPrimaryHoverFg = ControllerPaletteColor.GrayWhite,
  ContainedPrimaryDisabledBg = ControllerPaletteColor.Gray900,
  ContainedPrimaryDisabledFg = ControllerPaletteColor.Gray600,

  OutlinedPrimaryDefaultBg = ControllerPaletteColor.Transparent,
  OutlinedPrimaryDefaultFg = ControllerPaletteColor.Ngb500,
  OutlinedPrimaryHoverBg = ControllerPaletteColor.Transparent,
  OutlinedPrimaryHoverFg = ControllerPaletteColor.Ngb500,
  OutlinedPrimaryDisabledBg = ControllerPaletteColor.Transparent,
  OutlinedPrimaryDisabledFg = ControllerPaletteColor.Gray600,

  TextPrimaryDefaultBg = ControllerPaletteColor.Transparent,
  TextPrimaryDefaultFg = ControllerPaletteColor.Ngb500,
  TextPrimaryHoverBg = ControllerPaletteColor.Ngb900,
  TextPrimaryHoverFg = ControllerPaletteColor.Ngb500,
  TextPrimaryDisabledBg = ControllerPaletteColor.Transparent,
  TextPrimaryDisabledFg = ControllerPaletteColor.Gray600,

  IconPrimaryDefaultBg = ControllerPaletteColor.Transparent,
  IconPrimaryDefaultFg = ControllerPaletteColor.Ngb500,
  IconPrimaryHoverBg = ControllerPaletteColor.Ngb900,
  IconPrimaryHoverFg = ControllerPaletteColor.Ngb500,
  IconPrimaryDisabledBg = ControllerPaletteColor.Transparent,
  IconPrimaryDisabledFg = ControllerPaletteColor.Gray600,

  UnderlinePrimaryDefaultBg = ControllerPaletteColor.Transparent,
  UnderlinePrimaryDefaultFg = ControllerPaletteColor.Ngb400,
  UnderlinePrimaryHoverBg = ControllerPaletteColor.Transparent,
  UnderlinePrimaryHoverFg = ControllerPaletteColor.Ngb500,
  UnderlinePrimaryDisabledBg = ControllerPaletteColor.Transparent,
  UnderlinePrimaryDisabledFg = ControllerPaletteColor.Gray600,

  ContainedSecondaryDefaultBg = ControllerPaletteColor.Gray200,
  ContainedSecondaryDefaultFg = ControllerPaletteColor.GrayWhite,
  ContainedSecondaryHoverBg = ControllerPaletteColor.Gray400,
  ContainedSecondaryHoverFg = ControllerPaletteColor.GrayWhite,
  ContainedSecondaryDisabledBg = ControllerPaletteColor.Gray900,
  ContainedSecondaryDisabledFg = ControllerPaletteColor.Gray600,

  ContainedErrorDefaultBg = ControllerPaletteColor.Red400,
  ContainedErrorDefaultFg = ControllerPaletteColor.GrayWhite,
  ContainedErrorHoverBg = ControllerPaletteColor.Red500,
  ContainedErrorHoverFg = ControllerPaletteColor.GrayWhite,
  ContainedErrorDisabledBg = ControllerPaletteColor.Gray900,
  ContainedErrorDisabledFg = ControllerPaletteColor.Gray600,

  OutlinedSecondaryDefaultBg = ControllerPaletteColor.Transparent,
  OutlinedSecondaryDefaultFg = ControllerPaletteColor.Gray200,
  OutlinedSecondaryHoverBg = ControllerPaletteColor.Transparent,
  OutlinedSecondaryHoverFg = ControllerPaletteColor.Gray200,
  OutlinedSecondaryDisabledBg = ControllerPaletteColor.Transparent,
  OutlinedSecondaryDisabledFg = ControllerPaletteColor.Gray600,

  TextSecondaryDefaultBg = ControllerPaletteColor.Transparent,
  TextSecondaryDefaultFg = ControllerPaletteColor.Gray200,
  TextSecondaryHoverBg = ControllerPaletteColor.Gray900,
  TextSecondaryHoverFg = ControllerPaletteColor.Gray200,
  TextSecondaryDisabledBg = ControllerPaletteColor.Transparent,
  TextSecondaryDisabledFg = ControllerPaletteColor.Gray600,

  IconSecondaryDefaultBg = ControllerPaletteColor.Transparent,
  IconSecondaryDefaultFg = ControllerPaletteColor.Gray200,
  IconSecondaryHoverBg = ControllerPaletteColor.Gray900,
  IconSecondaryHoverFg = ControllerPaletteColor.Gray200,
  IconSecondaryDisabledBg = ControllerPaletteColor.Transparent,
  IconSecondaryDisabledFg = ControllerPaletteColor.Gray600,

  UnderlineSecondaryDefaultBg = ControllerPaletteColor.Transparent,
  UnderlineSecondaryDefaultFg = ControllerPaletteColor.Gray200,
  UnderlineSecondaryHoverBg = ControllerPaletteColor.Transparent,
  UnderlineSecondaryHoverFg = ControllerPaletteColor.Gray200,
  UnderlineSecondaryDisabledBg = ControllerPaletteColor.Transparent,
  UnderlineSecondaryDisabledFg = ControllerPaletteColor.Gray600,
}
